/* tslint:disable */
/* eslint-disable */
/**
 * Ак Барс Недвижимость API
 * Инструменты разработчика:  [ [Документация API. Swagger](/docs/) ]  [ [Документация API. Redoc](/redoc/) ] [ [Панель администрирования](/admin/) ] [ [Документация Image-Service](/api/Leads/docs/) ]
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';

interface LeadManager {
  name: string;
  email: string;
  phone: string;
}

interface LeadStatus {
  name: string;
  color: string;
  textColor: string;
}

interface File {
  uuid: string;
  fileName: string;
  fullUrl: string;
  ext: string;
}

interface Agreement {
  leadId: number;
  isNeedAgree: boolean;
  file: File;
  memoTitle: string;
  memoText: string;
}

interface LeadMemo {
  id: number
}

/**
 *
 * @export
 * @interface Lead
 */
export interface Lead {
  /**
   *
   * @type {number}
   * @memberof Lead
   */
  readonly leadId?: number;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  readonly objectType?: string;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  readonly objectZhk?: string;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  objectBuildingNumber?: string | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  objectNumber?: string | null;
  /**
   *
   * @type {LeadStatus}
   * @memberof Lead
   */
  status?: LeadStatus | null;
  /**
   *
   * @type {string}
   * @memberof Lead
   */
  contractSum?: string | null;
  /**
   *
   * @type {LeadManager}
   * @memberof Lead
   */
  manager?: LeadManager | null;

  /**
   *
   * @type {string}
   * @memberof Lead
   */
  memo?: string | null;

  /**
   * @type {LeadMemo}
   */
  leadMemo?: LeadMemo | null;

  /**
   *
   * @type {Agreement}
   * @memberof Lead
   */
  agreement?: Agreement | null;

  isPossibleMortgage?: boolean;
  hasCheckLists?: boolean;
}

export function LeadFromJSON(json: any): Lead {
  return LeadFromJSONTyped(json);
}

export function LeadFromJSONTyped(json: any): Lead {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    leadId: !exists(json, 'leadId') ? undefined : json['leadId'],
    objectType: !exists(json, 'objectType') ? undefined : json['objectType'],
    objectBuildingNumber: !exists(json, 'objectBuildingNumber') ? undefined : json['objectBuildingNumber'],
    objectNumber: !exists(json, 'objectNumber') ? undefined : json['objectNumber'],
    objectZhk: !exists(json, 'objectZhk') ? undefined : json['objectZhk'],
    status: !exists(json, 'status') ? undefined : json['status'],
    contractSum: !exists(json, 'contractSum') ? undefined : json['contractSum'],
    manager: !exists(json, 'manager')
      ? undefined
      : {
          name: json['manager']['name'],
          email: json['manager']['email'],
          phone: json['manager']['phone'],
        },
    agreement: !exists(json, 'agreement')
      ? undefined
      : {
          leadId: json['agreement']['leadId'],
          isNeedAgree: json['agreement']['isNeedAgree'],
          file: json['agreement']['file'],
          memoTitle: json['agreement']['memoTitle'],
          memoText: json['agreement'],
        },
    memo: !exists(json, 'memo') ? undefined : json['memo'],
    leadMemo: !exists(json, 'leadMemo') ? undefined : json['leadMemo'],
    isPossibleMortgage: !exists(json, 'isPossibleMortgage') ? undefined : json['isPossibleMortgage'],
    hasCheckLists: !exists(json, 'hasCheckLists') ? undefined : json['hasCheckLists'],
  };
}

export function LeadToJSON(value?: Lead | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    leadId: value.leadId,
    objectType: value.objectType,
    objectBuildingNumber: value.objectBuildingNumber,
    objectNumber: value.objectNumber,
    objectZhk: value.objectZhk,
    status: value.status,
    contractSum: value.contractSum,
    manager: value.manager,
    memo: value.memo,
    leadMemo: value.leadMemo,
    agreement: value.agreement,
    isPossibleMortgage: value.isPossibleMortgage,
    hasCheckLists: value.hasCheckLists,
  };
}
